var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SimpleTextPopup", {
    attrs: {
      title: _vm.$t("labelInvoiceDetailsTitle", {
        clientName: _vm.client.clientName ? _vm.client.clientName + " " : ""
      }),
      hideRgtBtn: true,
      outsideScrollToBottom: _vm.outsideScrollToBottom,
      medium: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-layout",
              { attrs: { row: "", "justify-space-around": "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { xs6: "", md6: "", xl6: "", lg4: "" } },
                  [
                    _c("DatePicker", {
                      attrs: {
                        label: _vm.$t("date"),
                        range: "",
                        min: _vm.dateMin,
                        max: _vm.dateMax
                      },
                      model: {
                        value: _vm.dates,
                        callback: function($$v) {
                          _vm.dates = $$v
                        },
                        expression: "dates"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { md3: "", xl2: "", lg2: "" } },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          dark: "",
                          color: "primary",
                          disabled: !_vm.isClient,
                          loading: _vm.isGenerateLoading
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.generateFile(
                              _vm.tenantKey,
                              _vm.dates[0],
                              _vm.dates[1]
                            )
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("generate")))]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { md3: "", xl2: "", lg2: "" } },
                  [
                    _vm.isModeLabel
                      ? _c(
                          "v-btn",
                          {
                            attrs: {
                              dark: "",
                              color: "primary",
                              loading: _vm.freshLoading
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.freshTransactions.apply(
                                  null,
                                  arguments
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("fresh")))]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  {
                    staticClass: "red--text font-weight-bold text-xs-left",
                    attrs: { "align-self-center": "" }
                  },
                  [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("v-data-table", {
              staticClass: "my-1 levation-2 myDense",
              attrs: {
                headers: _vm.headers,
                items: _vm.isModeLabel
                  ? _vm.apiExportTransactions
                  : _vm.client.labelInvoices || [],
                pagination: _vm.pagination,
                "rows-per-page-items": _vm.rowPerPage
              },
              on: {
                "update:pagination": function($event) {
                  _vm.pagination = $event
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "items",
                  fn: function(props) {
                    return [
                      _c("td", { staticClass: "subheading" }, [
                        _vm._v(
                          _vm._s(
                            String(props.item.file)
                              .split("/")
                              .pop()
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-xs-left" }, [
                        _vm._v(
                          _vm._s(
                            _vm.toDateYYYYMMDDHHmm(
                              new Date(props.item.createTime)
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "text-xs-right" },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        disabled: !_vm.isClient,
                                        flat: "",
                                        dark: "",
                                        icon: "",
                                        color: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          _vm.downloadFile(
                                            props.item.file,
                                            String(props.item.file)
                                              .split("/")
                                              .pop(),
                                            props.item.fileUrl
                                          )
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("file_download")])],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                [
                                  !_vm.isModeLabel
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            disabled:
                                              !_vm.isClient ||
                                              (_vm.isDeleteLoading &&
                                                _vm.currentDeleteFile !=
                                                  props.item.file),
                                            flat: "",
                                            dark: "",
                                            icon: "",
                                            color: "primary",
                                            loading:
                                              _vm.isDeleteLoading &&
                                              _vm.currentDeleteFile ===
                                                props.item.file
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.deleteFile(
                                                _vm.tenantKey,
                                                props.item.file
                                              )
                                            }
                                          }
                                        },
                                        [_c("v-icon", [_vm._v("delete")])],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            })
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-81b4582e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81b4582e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LabelInvoiceDetails.vue
// module id = null
// module chunks = 